export enum AirAmbulanceMembershipOptions {
  AutoRenewal = 'autoRenewal',
  SendWelcomeEmail = 'sendWelcomeEmail',
  EmailOptOut = 'emailOptout',
}
